// store.js
import { writable } from 'svelte/store';

export const film = writable('');
export const jwt = writable(localStorage.getItem('token'));